import axios from 'axios';
import envService from "@/services/env.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/outbox';

export default {

    getSmsOutbox(webId, countryCode, destinationNumber, status, tag, dateFrom, dateTo, page, size, sort) {
        const params = {
            'countryCode': countryCode !== undefined && countryCode !== null && countryCode.length > 0 ? countryCode.toUpperCase() : countryCode,
            'destinationNumber': destinationNumber,
            'status': status + "",
            'searchTag': tag,
            'dateFrom': dateFrom,
            'dateTo': dateTo,
            'page': page,
            'size': size,
            'sort': sort
        }
        if (webId && webId !== 'all_apps') {
            params.webId = webId;
        }
        return axios.get(BASE_URL + '/statistic', {params: params});
    },

    getOutboxExport(webId, countryCode, destinationNumber, status, tag, from, to) {
        const params = {
            'countryCode' : countryCode !== undefined && countryCode !== null && countryCode.length > 0 ? countryCode.toUpperCase() : countryCode,
            'destinationNumber' : destinationNumber,
            'status' : status+"",
            'searchTag' : tag,
            'from' : from,
            'to' : to
        }
        if (webId && webId !== 'all_apps') {
            params.webId = webId;
        }
        return axios.get(BASE_URL + '/export', { params: params, responseType: 'arraybuffer'})
    }
}
